import React from 'react';
import { IconButton, Typography, Button,Box } from '@mui/material';
import * as _ from 'lodash'
import { initObjectPaymentCard, PaymentCardT } from '../../../types/Payments';
import { currentUserIsManager } from '../../../utils/currentUser';
import LineItemCard from './LineItemCard';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export interface IListCreditCardsCheckoutProps {

    cards?: Array<PaymentCardT>
    onRefreshCards?(): void
    primaryCard?: PaymentCardT
    onChangePrimaryCard(card: PaymentCardT): void
    stripe?: any
    back(): void
    // charge?(card: ItemCard): Promise<void>
}

const ListItemCards: React.FC<IListCreditCardsCheckoutProps> = (props) => {

    // let auth = useSelector((state: IAppState) => state.auth)
    // const roles = auth && auth.userData && auth.userData.roles ? auth.userData.roles : []

    const [isReady, setIsReady] = React.useState(false);
    const userIsManager = currentUserIsManager()



    const [amount, setAmount] = React.useState(0);

    React.useEffect(() => {
        setIsReady(true)
    }, []);



    return (
        <Box className="p-2 mt-2 w-100"  >
            <Typography variant="h4">Cards on File</Typography>
            {/* {!isReady &&
                <Container className="mt-5 text-center">
                    <Spinner animation="border" variant="info" />
                </Container>} */}

            {(!isReady || !props.stripe) && [1, 2].map((item, index) => {
                return (
                    <LineItemCard
                        isSkeleton={true}
                        isLoading={true}
                        key={index}
                        item={initObjectPaymentCard}

                        primaryCard={props.primaryCard}

                    />
                )
            })}

            {props.stripe && isReady && props.cards.map((item, index) => {
                return (
                    <LineItemCard
                        isLoading={false}
                        key={index}
                        stripe={props.stripe}
                        item={item}
                        primaryCard={props.primaryCard}
                        onChangeCard={(card) => {
                            props.onChangePrimaryCard(card)
                            props.onRefreshCards()

                        }}

                    />
                )
            })}

            {/* <IconButton onClick={(e) => {
                e.preventDefault()
                props.back()
            }}>
                <ArrowBackIcon />
            </IconButton> */}
        
        </Box>
    );
}
export default ListItemCards
export { ListItemCards }